import React from "react";
import ReportDashboard from "./ReportDashboard";
import Header from "../header/header";
import Footer from "../footer/footer";
import NavBar from "../nav/nav-bar";
import ReportNav from "./report-nav";
import { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-multi-date-picker";
import Toolbar from "react-multi-date-picker/plugins/toolbar";
import { Link, useHistory } from "react-router-dom";
import Service from "../webservice/http";
import ClipLoader from "react-spinners/ClipLoader";
import { useSelector, useDispatch } from "react-redux";
import { makeVisible } from "../features/my-report";

function Report() {
  const savedReportVisiblity = useSelector((state) => state.myreport.visible);
  const history = useHistory();
  const dispatch = useDispatch();
  const services = new Service();
  const [range, setRange] = useState("");
  const [value, setValue] = useState([
    new Date().setMonth(new Date().getMonth() - 1),
    new Date(),
  ]);
  const [selectedValues, setSelectedValues] = useState({});
  const [reportResponse, setReportResponse] = useState(null);
  const [Loading, setLoading] = useState(false);
  const [delmodal, setDelmodal] = useState(false);
  const [Savedreportdetail, setSavedreportdetail] = useState([]);
  const [dropdown, setDropdown] = useState([]);
  const [delid, setDelid] = useState("");

  const formatLabel = (str) => {
    const words = str.replace(/_/g, " ").split(" ");

    return words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const handleDates = (dates) => {
    if (dates) {
      const range = dates.map((date) => {
        return date.format("DD/MM/YYYY");
      });
      setRange(range);
    }
  };

  const dropdowns = [
    {
      name: "callDate",
      label: "Call Date",
      options: [],
    },
    {
      name: "agent",
      label: "Agent",
    },
    {
      name: "productName",
      label: "Product Name",
    },
    {
      name: "manager",
      label: "Manager",
    },
    {
      name: "sentiment",
      label: "Sentiment",
    },
    {
      name: "intent",
      label: "Intent",
    },
    {
      name: "callLanguage",
      label: "Call Language",
    },
    {
      name: "call_opening",
      label: "Call Opening",
    },
    {
      name: "process_compliance",
      label: "Process Compliance",
    },

    {
      name: "call_closing",
      label: "Call Closing",
    },
    {
      name: "customer_experience",
      label: "Customer Experience",
    },
    {
      name: "documentation",
      label: "Document",
    },
    {
      name: "service_policy_compliance",
      label: "Service and Policy Compliance",
    },
    {
      name: "negotiation_strategy",
      label: "Negotiation Strategy",
    },
  ];

  const fetchparameters = async () => {
    setLoading(true);
    try {
      const response = await services.get(
        "api/call_verification/collect_parameters/",
      );

      const apiData = response;
      const updatedDropdowns = dropdowns.map((dropdown) => {
        const apiKey = {
          agent: "agents",
          productName: "products",
          manager: "team_leads",
          sentiment: "sentiments",
          intent: "intents",
          callLanguage: "call_languages",
          call_opening: "call_opening",
          process_compliance: "process_compliance",
          call_closing: "call_closing",
          customer_experience: "customer_experience",
          documentation: "documentation",
          service_policy_compliance: "service_policy_compliance",
          negotiation_strategy: "negotiation_strategy",
        }[dropdown.name];

        return {
          ...dropdown,
          options:
            apiData[apiKey]?.map((item) => ({
              value: item,
              label: formatLabel(item),
            })) || [],
        };
      });

      setDropdown(updatedDropdowns);
      setLoading(false);
    } catch (error) {
      console.error("API Error:", error.message);
    }
  };

  useEffect(() => {
    fetchparameters();
  }, []);

  const handleCreateReport = async () => {
    setLoading(true);

    const reportData = {};
    dropdowns.forEach((dropdown) => {
      if (dropdown.name === "callDate") {
        reportData[dropdown.name] = range;
      } else {
        const selected = selectedValues[dropdown.name] || [];
        reportData[dropdown.name] = selected.map((option) => option.value);
      }
    });
    try {
      const response = await services.post(
        "api/call_verification/collect_parameters/",
        reportData,
      );
      setReportResponse({ status: "success", data: response });
      setLoading(false);
      history.push("/reports/my-reports-details", { reportData: response });
      dispatch(makeVisible());
    } catch (error) {
      setReportResponse({ status: "error", message: error.message });
      console.error("API Error:", error.message);
    }
  };

  const fetchReports = async () => {
    setLoading(true);
    try {
      const response = await services.get("api/call_verification/save_report/");

      let reportData = response.map((item) => ({
        name: item.report_name,
        id: item.id,
        user: item.user,
      }));

      setSavedreportdetail(reportData);
      setLoading(false);
    } catch (error) {
      console.error("API Error:", error.message);
    }
  };
  useEffect(() => {
    fetchReports();
  }, [savedReportVisiblity]);

  const handleDeleteReport = async () => {
    setLoading(true);
    try {
      await services.delete(
        `api/call_verification/save_report/?report_id=${delid}`,
      );
      fetchReports();
      setLoading(false);
      setDelmodal(false);
    } catch (error) {
      console.error("API Error:", error.message);
      setLoading(false);
    }
  };

  return (
    <div>
      <Header />
      <NavBar />

      <div className="container-fluid" style={{ background: "#EEF2F5" }}>
        <div className="my-call">
          <div
            className="side-panel-with-table clearfix flex"
            style={{ display: "flex" }}
          >
            {savedReportVisiblity && <ReportNav />}
            <div
              className={`call-table ${savedReportVisiblity ? "bg-white" : ""}`}
              style={{
                marginBottom: savedReportVisiblity ? "80px" : "0",
                flex: savedReportVisiblity ? undefined : 1,
                display: "flex",
                flexDirection: "column",
                padding: "0px",
              }}
            >
              <div
                className="my-calls-column bg-white"
                style={{
                  padding: savedReportVisiblity
                    ? "15px 0px 0px 15px"
                    : "10px 15px",
                  borderBottom: savedReportVisiblity
                    ? "none"
                    : "1px solid #dde2e6",
                }}
              >
                <div className="calls-top-pannel">
                  <div className="row">
                    <div className="flex justify-between items-center px-6">
                      <div className="pannel-heading clearfix flex items-center">
                        <div className="pannel-heading-icon">
                          <i
                            className="fa fa-file-text-o"
                            aria-hidden="true"
                          ></i>
                        </div>
                        <div className="pannel-heading-info">
                          <h3>My Reports</h3>
                        </div>
                      </div>
                      <div className="mr-8">
                        <button
                          className="px-5 py-3 mb-4 rounded-lg font-semibold hover:text-white text-gray-700 bg-white run-my-report hover:border-0"
                          onClick={() => {
                            // setMyreport(!myreport);
                            dispatch(makeVisible());
                          }}
                        >
                          {!savedReportVisiblity ? "Saved Report" : "+ New "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                {Loading ? (
                  <div
                    className="flex justify-center items-center"
                    style={{ height: "100vh" }}
                  >
                    {" "}
                    <ClipLoader color="#2056FF" size="50px" />
                  </div>
                ) : savedReportVisiblity ? (
                  <div className="mx-auto mt-10 bg-white rounded-lg shadow-md p-4">
                    <div className="flex justify-between  bg-gray-600 text-white font-semibold px-24 py-5 rounded-t-lg">
                      <div style={{ width: "135px" }}>Files</div>
                      <div style={{ marginRight: "64px" }}>Action</div>
                    </div>
                    {Savedreportdetail.length === 0 && !Loading ? (
                      <div
                        className=" flex justify-center items-center font-semibold text-2xl"
                        style={{ height: "100px" }}
                      >
                        No Reports Found
                      </div>
                    ) : (
                      <div
                        className="divide-y divide-gray-200 overflow-y-auto"
                        style={{ maxHeight: "625px" }}
                      >
                        {Savedreportdetail?.map((report, index) => (
                          <div
                            key={index}
                            className=" flex justify-between px-20 py-5 hover:bg-gray-50 "
                          >
                            <div
                              className="text-gray-800 "
                              // style={{ marginLeft: "-20px" }}
                              style={{ width: "170px" }}
                            >
                              {report.name}
                            </div>
                            <div
                              style={{ marginRight: "-18px" }}
                              className=" flex gap-2"
                            >
                              <button
                                className="border-gray-300 px-4 py-2 text-gray-700 rounded-lg hover:text-white hover:bg-blue-800"
                                style={{ border: "1px solid #ccc" }}
                                onClick={() =>
                                  history.push(
                                    `/reports/saved-reports-details/${report.id}`,
                                  )
                                }
                              >
                                View Report
                              </button>
                              <button
                                className="border-gray-300 px-4 py-2 text-gray-700 rounded-lg hover:text-white hover:bg-red-600"
                                style={{ border: "1px solid #ccc" }}
                                onClick={() => {
                                  setDelmodal(true);
                                  setDelid(report?.id);
                                }}
                              >
                                Delete Report
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <ReportDashboard />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {delmodal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div
            className="bg-white rounded-lg shadow-lg p-6 relative"
            style={{ width: "350px", height: "180px" }}
          >
            <h4 className="font-semibold mb-4 text-center">
              Do you want to delete the report ?
            </h4>

            <div className="flex gap-4 justify-center items-center mt-8 font-medium">
              <button
                onClick={() => setDelmodal(false)}
                className="px-4 py-3 text-gray-700 bg-gray-200 rounded-md hover:bg-green-800 hover:text-white font-medium"
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteReport}
                className="px-4 py-3  rounded-md hover:bg-red-600 bg-gray-200 hover:text-white "
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
}

export default Report;
